define([
	"dojo/_base/declare",
	"dojo/html",
	"csi/access/crews",
	"csi/action",
	"csi/action/_NewCommentMixin",
	"csi/action/Controller",
	"csi/html",
	"csi/html/Widget",
	"csi/locale",
	"csi/page/HelpPane",
	"csi/sessionConstants",
	"csi/state/rootStore",
	"csi/utility/stringUtility",
	"csi/xml",
	"dojo/text!csi/templates/htmlPageHelp.html"
], function(declare, html, crews, csiAction, _NewCommentMixin, Controller, csiHtml, HtmlWidget, locale, HelpPane, sessionConstants, {routerStore, watchStoreProperty}, {trimmedString}, xml, template) {

	var _ContentSetter = declare(html._ContentSetter, {
		set: function(/* String|DomNode|NodeList? */ cont, /* Object? */ params) {
			// summary: override _ContentSetter to allow for variable substitution which allows for localization
			this._helpContent = cont;
			cont = cont.replace(/\${(.*?)}/g, "${$1:_nls}");
			return this.inherited(arguments);
		}
	});

	var _EditController = declare([Controller, _NewCommentMixin], {
		preProcess: function() {
			// summary: popup comment dialog
			const text = this.widget.get("help");
			this.edit(this.getTitle(), {text});
		},

		preProcessContinue: function() {
			// summary: ready to process
			this.process();
		},

		toWriter: function() {
			// summary: add parameters to request
			this.m_writer.callMethod("SiteAdmin", "SaveContextHelpFile")
				.addParameter("Locale", xml.ATTR_STRING, locale.getLocale())
				.addParameter("NodeType", xml.ATTR_STRING, this.widget._tabType)
				.addParameter("ViewId", xml.ATTR_STRING, this.widget._tabView)
				.addParameter("Content", xml.ATTR_STRING, this.commentValues.text);
		},

		postProcessSuccess: function() {
			// summary: update view with new content
			this.widget.set("help", this.commentValues.text);
		}
	});

	var EDIT_ACTION = "EditHelp";
	var _Missing = {};

	function _getTabId(type, id) {
		return type + "/" + id;
	}

	return declare(HtmlWidget, {
		templateString: template,

		// DOMNode: attach points
		_helpNode: null,

		// String: current node type and view id for which help is displayed
		_tabType: null,
		_tabView: null,

		onViewError: function(/*Error*/err) {
			// summary: keep track of failed requests, but allow view to keep working
			_Missing[_getTabId(this._tabType, this._tabView)] = true;
			this._endView();
		},

		postCreate: function() {
			// summary: pre-process ContentPane - if config editor who can edit help, then prevent caching of help files
			this.inherited(arguments);

			if (sessionConstants.configEditor || crews.isInGlobalRoles(["Help Pane Editor"])) {
				this.contentNode.preventCache = true;
			} else {
				this.editNode.destroyRecursive();
				this.editNode = null;
			}

			this.contentNode.errorMessage = this.contentNode.loadingMessage = " ";
			this.contentNode._contentSetter = new _ContentSetter({node: this.contentNode.containerNode});

			// initialize pane
			this._onUpdate();

			// watch for subscribe to hash changes
			const watchFunction = () => this._onUpdate();

			this.own(
				watchStoreProperty(routerStore, "_helpType", watchFunction),
				watchStoreProperty(routerStore, "_helpView", watchFunction)
			);
		},

		_clearMissing: function() {
			_Missing[_getTabId(this._tabType, this._tabView)] = false;
		},

		_getHelpAttr: function() {
			// summary: return content from file rather than after parameterization
			return trimmedString(this.contentNode._contentSetter._helpContent);
		},

		_setHelpAttr: function(/*String*/s) {
			// summary: return content from file rather than after parameterization
			this._clearMissing();
			return this.setContent(s);
		},

		_hasToolbar: function() {
			// summary: show toolbar for this view
			return true;
		},

		_onEdit: function() {
			// summary: edit the chart
			csiAction.invoke(this, this.domNode, EDIT_ACTION);
		},

		_onUpdate: function() {
			// summary: set template for Html view based on current tab
			const {helpTitle, helpType, helpView} = routerStore;
			const {
				contentNode,
				editNode,
				removeNode,
				titleNode,
				_tabType,
				_tabView
			} = this;

			if (helpView) {
				// only update help if view changed
				if ((helpView != _tabView) || (helpType != _tabType)) {
					this._tabType = helpType;
					this._tabView = helpView;

					// update help title bar
					csiHtml.setInnerText(titleNode, `${locale.resource("Help")}: ${helpTitle}`);

					// skip request for help file if we have already requested this resource and found it missing
					const key = _getTabId(helpType, helpView);

					if (_Missing[key]) {
						this.setContent(contentNode.errorMessage);
					} else {
						this.setTemplate("ContextHelp/" + locale.getLocale() + "/" + key + ".html");
					}
				}
			} else {
				// no tab, so clear content
				this._tabType = this._tabView = null;
				this.setContent(contentNode.errorMessage);
				csiHtml.setInnerText(titleNode, locale.resource("Help"));
			}

			if (editNode) {
				editNode.set("disabled", !helpView);
			}

			removeNode.set("disabled", false);
		},

		_onLoadTemplate: function() {
			// summary: after template loaded, ready to start processing
			if (this._tabType) {
				_Missing[_getTabId(this._tabType, this._tabView)] = (this.contentNode.get("content") == this.contentNode.errorMessage);
			}

			this._processFade();
			this.inherited(arguments);
		},

		_onRemove: function() {
			// summary: close help pane
			HelpPane.close();
		},

		_resolveView: function() {
			// summary: clear toolbar - it is specified in template
			this.defView._addViewAction(EDIT_ACTION, {classController: _EditController});
			this.plugins = null;
			this.inherited(arguments);
		}
	});
});